import {
  Domain,
  type DomainAttributesType
} from './Ambiguous'

export class LoadedDomain<T extends DomainAttributesType = DomainAttributesType> extends Domain<T> {
  readonly isLoaded: true = true

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor (attributes: T) {
    super(attributes)
  }
}
